import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { classNames } from '../../../../../shared/libs/classNames';
import { SettingsButton } from '../../../../../shared/ui';
import { useAppDispatch, useAppSelector } from '../../../../../shared/libs/redux';
import { NewModal } from '../../../../../components/ui/modals/new-modal';
import {
	workshopModuleActions,
	workshopModuleSelectors,
	workshopModuleSlice,
} from '../../../../../entities/module/workshop-module';
import css from './WorkshopModulesModal.module.scss';
import { DeleteWorkshopModuleModal } from '../../../../../features/manage-workshop-module';
import { WorkshopModulesModalList } from '../modules-list/WorkshopModulesModalList';
import { UnbindWorkshopTagModal } from '../../../../../features/manage-workshop-module-tags';
import { workshopModuleTagSlice } from '../../../../../entities/module/workshop-module-tag';
import { WorkshopModulesCategoriesBar } from '../categories/bar/WorkshopModulesCategoriesBar';
import SearchByModulesInput from '../../../../../components/ui/searchByModulesInput/SearchByModulesInput';
import { ModuleTagGroupScrollBar } from '../../../../modules/tag-groups-scroll-search-panel';
import { TypeOfTags } from '../../../private-template-modules-modal/model/types';
import {
	workshopModuleTagSelectors,
} from '../../../../../entities/module/private-template-module-tag/model/workshop-module-tag/slice/workshopModuleTagSlice';
import {
	useSelectedModuleGroupTags,
} from '../../../../modules/tag-groups-scroll-search-panel/libs/workshop/useSelectedModuleGroupTags';
import {
	workshopModuleTagsSettingsSelectors,
} from '../../../../../features/module/tag-group/workshop-module-tag-group-settings/slice/workshopModuleTagsSettingsSlice';
import {
	WorkshopModuleTagList,
} from '../../../../../features/module/tag-group/workshop-module-tag-group-settings/ui/Group-tag-list/WorkshopModuleTagList';
import {
	workshopModuleTagGroupSelectors,
} from '../../../../../entities/module/tag-group/workshop-module-tag-group/model/slice/workshopModuleTagGroupSlice';

interface IWorkshopModulesModalProps {
	className?: string,
}

/**
 * Модальное окно модулей мастерской.
 */
export const WorkshopModulesModal = ({ className }: IWorkshopModulesModalProps) => {
	const dispatch = useAppDispatch();
	const scrollRef = useRef<HTMLDivElement>(null);

	const [search, setSearch] = useState('');

	const isActive = useSelector(workshopModuleSlice.selectors.getIsModulesModalActive);

	const isEditModulesActive = useSelector(workshopModuleSlice.selectors.getIsEditModuleModalActive);
	const isDeleteModuleActive = useSelector(workshopModuleSlice.selectors.getIsDeletingModuleModalActive);

	const isUnbindTagActive = useSelector(workshopModuleTagSlice.selectors.getIsUnbindingModalActive);
	const isBindingTagActive = useSelector(workshopModuleSlice.selectors.getIsBindingTagModuleModalActive);

	const isEditCategoryActive = useAppSelector(state => state.category.modalsActive.isEditCategoryModalActive);
	const isDeleteCategoryActive = useAppSelector(state => state.category.modalsActive.isDeletingCategoryModalActive);

	const isDeleteWorkshopModuleTagModalActive = useSelector(
		workshopModuleTagSelectors.getIsDeleteModuleTagModalActive,
	);

	const isCreateWorkshopModuleGroupModalActive = useSelector(
		workshopModuleTagGroupSelectors.getIsCreateGroupModalActive,
	);

	const isWorkshopModuleTagsSettingsModalActive = useSelector(
		workshopModuleTagsSettingsSelectors.getIsTagsSettingsModalActive,
	);

	const onModuleClick = useSelector(workshopModuleSelectors.getOnModuleClick);

	const editor = useAppSelector(workshopModuleSelectors.getEditor);

	const handleModal = () => {
		dispatch(workshopModuleActions.setIsModulesModalActive({ editor, active: false }));
		dispatch(workshopModuleActions.setCategories([]));
	};

	const openEditModulesWindow = () => {
		dispatch(workshopModuleActions.setIsEditModuleModalActive(true));
	};

	const {
		selectedTags,
		onRemoveTag,
	} = useSelectedModuleGroupTags(TypeOfTags.WORKSHOP_TAGS);

	const removeCreatedGroupTags = (tag: string) => {
		onRemoveTag(Number(tag));
	};

	return (
		<NewModal
			active={isActive}
			closeFunc={handleModal}
			modalInModalActive={
				isEditModulesActive
					|| isDeleteModuleActive
					|| isUnbindTagActive
					|| isBindingTagActive
					|| isEditCategoryActive
					|| isDeleteCategoryActive
					|| isDeleteWorkshopModuleTagModalActive
					|| isCreateWorkshopModuleGroupModalActive
					|| isWorkshopModuleTagsSettingsModalActive
			}
		>
			<div className={classNames(css.wrapper, {}, [className])}>
				<div className={css.content} ref={scrollRef}>
					<div className={css.search_block}>

						{/* Поиск по модулям */}
						<SearchByModulesInput
							onChange={setSearch}
							placeholder="Поиск по модулям"
							searchValue={search}
							styles={css.search}
						/>

						{/* Виджет с группами тегов */}
						<ModuleTagGroupScrollBar
							scrollDistance={200}
							typeOfTags={TypeOfTags.WORKSHOP_TAGS}
							scrollRef={scrollRef}
						/>

						{selectedTags.length > 0 && (
							<WorkshopModuleTagList
								selectedTags={selectedTags}
								onRemoveChoicedItem={removeCreatedGroupTags}
							/>
						)}
						{/* <div className={css.scroll_wrapper} /> */}
					</div>

					<WorkshopModulesModalList onModuleClick={onModuleClick} search={search} />
				</div>

				{/* Блок с категориями и поиском по категориям  */}
				<div className={css.manage_bar}>
					<div className={css.categories}>
						<WorkshopModulesCategoriesBar />
					</div>
					<SettingsButton onClick={openEditModulesWindow} />
				</div>
			</div>
			<UnbindWorkshopTagModal />
			<DeleteWorkshopModuleModal />
		</NewModal>
	);
};
